import { render, staticRenderFns } from "./FabricanteDetail.vue?vue&type=template&id=06a9a286&scoped=true"
import script from "./FabricanteDetail.vue?vue&type=script&lang=js"
export * from "./FabricanteDetail.vue?vue&type=script&lang=js"
import style0 from "./FabricanteDetail.vue?vue&type=style&index=0&id=06a9a286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a9a286",
  null
  
)

export default component.exports